import { render, staticRenderFns } from "./VerifyCenter.vue?vue&type=template&id=5285bad0"
import script from "./VerifyCenter.vue?vue&type=script&lang=js"
export * from "./VerifyCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports